package ru.villawonka.app.domain.model

data class PaginatedResult<T>(
    val totalCount: Int,
    val currentPage: Int,
    val pageSize: Int,
    val hasNext: Boolean,
    val data: List<T>,
) {

    sealed class Failure {

        data object NoMoreData : Failure()

        data class Network(val failure: NetworkFailure) : Failure()
    }
}
